export const successMessages = [
    "Zázrak sa stal! Automat pustil centy!",
    "Konečne! Aj slepé kura našlo zrno.",
    "Zbohatol som o dve euro – ideme baliť kufre!",
    "Vyhral som! Idem si kúpiť rožok a žuvačku.",
    "Automat sa zľutoval. Asi omylom.",
    "Som bohatý... na chvíľu.",
    "Kasíno mi práve dovolilo existovať o deň dlhšie.",
    "Toľko šťastia... určite ma zajtra zrazí auto.",
    "Dnes večer sa oslavuje – s minerálkou!",
    "Vyhral som viac, ako som mal na účte minulý týždeň!",
    "Jackpot! Ale len pre moje ego.",
    "Cinklo to! A ja som skoro odpadol.",
    "Automat si ma asi pomýlil s niekým iným.",
    "Už mi chýba len jachta a vlastný ostrov.",
    "Zabudnite na prácu, idem hrať profesionálne!",
    "Odteraz ma oslovujte: Lord Výherný.",
    "Na chvíľu som bol bohatší ako moje sny.",
    "Peniaze zadarmo? Idem ich hneď vrátiť späť!",
    "S týmto výhrou si kúpim... ďalší pokus.",
    "A to mi mama hovorila, že nič v živote nedosiahnem!"
];

export const failureMessages = [
    "Cely som vyzváraný, aj iskry mi z peňaženky lietali.",
    "Zase som nakŕmil plechového zlodeja.",
    "Automat 1 : Ja 0 – ako vždy.",
    "Odišiel som bohatší o skúsenosť… a chudobnejší o výplatu.",
    "Ten automat ma zbil bez ruky.",
    "Zlaté rybky chytám, ale zlatá žiadna.",
    "V automate mám vlastnú parcelu, toľko som mu tam nechal.",
    "Keby to bol súboj rozumu, tak by som prehral ešte skôr.",
    "Dal som mu všetko. A on mi dal veľké nič.",
    "Myslel som, že vyhrám... myslel som zle.",
    "Mám šťastie – ale len v láske. A aj to je otázne.",
    "Opäť som sponzoroval kasíno. Dobrovoľne.",
    "Automat mi vrátil presne to, čo som si zaslúžil – facku.",
    "Dal som mu päťku a on mi dal trauma.",
    "Ešte aj ten automat sa na mňa škodoradostne usmieval.",
    "Som späť na nule. Presne tam, kde som začal. Ale s menšou hrdosťou.",
    "Moje šťastné číslo je vypnuté.",
    "Ak by to bola hra trpezlivosti, bol by som šampión… v prehre.",
    "Mohol som si za to kúpiť večeru. Ale nie, ja som musel ísť ‘investovať’.",
    "Zase som naprogramovaný na bankrot.",
    "Ešte jeden spin a vyhrám všetko naspäť",
    "Nesmieš prestať v tom najlepšom",
    "Prehráš len keď sa rozhodneš skončiť",
    "Automat ma oholil do posledného centu.",
    "Myslel som, že som vyhral, ale bol to len sen.",
    "Zase som prehral, ale aspoň mám nový príbeh na rozprávanie.",
    "Automat mi ukázal, kto je tu pán.",
    "Moja peňaženka je prázdna, ale moje sny sú stále drahé.",
    "Vyhral som... nič. Ako vždy.",
    "Automat ma naučil, že šťastie nie je na mojej strane.",
    "Dnes som sponzoroval kasíno. Zase.",
    "Myslel som, že som šikovný, ale automat ma presvedčil o opaku.",
    "Moje šťastné číslo je stále na dovolenke.",
    "Automat mi dal lekciu pokory. A vzal všetko ostatné.",
    "Zase som si kúpil lístok na vlak do straty.",
    "Moje šťastie je ako Wi-Fi signál – slabé a nestabilné.",
    "Automat mi ukázal, že nádej je drahá.",
    "Prehral som, ale aspoň som sa naučil, že nesmiem prestať."
];